module.exports = __webpack_public_path__ + "img/08Entertainment.fefabed6.png";